// extracted by mini-css-extract-plugin
export default {"clients":"Clients_clients__QiAq2","client":"Clients_client__V8ogC","allClients":"Clients_allClients__QvH7k"};